import { EPriceTabView } from "MVVM/@types";
import { experimentBucket } from "./experimentBucket";

export const BASIC_PLAN_EXPERIMENT = "basic_plan_choice_v1";
export const BASIC_PLAN_LOOKUP = "basic_plan_choice_v1_basic_monthly";
export type BasicPlanVariant = "control" | "treatment";

export const basicPlanVariant = (userId: string): BasicPlanVariant =>
  experimentBucket(BASIC_PLAN_EXPERIMENT, userId) < 0.5
    ? "control"
    : "treatment";

export const basicPlanPricing = {
  monthly: "$2.99",
  monthlyAnnual: "$35.88",
  annual: "$2.99",
  annualTotal: "",
  discount: "",
};

// Basic has no annual offer in this experiment. Keep the card visible in both
// tabs, clearly label monthly billing, and use monthly cadence for its cart.
export const planBillingPeriod = (
  variant: BasicPlanVariant | undefined,
  plan: string | null | undefined,
  selectedPeriod: EPriceTabView,
): EPriceTabView =>
  variant === "treatment" && plan === "ESSENTIALS"
    ? EPriceTabView.Monthly
    : selectedPeriod;

export const experimentTiers = (variant?: BasicPlanVariant) =>
  variant === "treatment"
    ? (["ESSENTIALS", "CREATOR_PLAT"] as const)
    : (["CREATOR_PLAT"] as const);
